import { useParams } from "react-router-dom";
import { Box } from "@mantine/core";

import ColorsTabSkeleton from "./ColorsTabSkeleton";
import TypographyTabSkeleton from "./TypographyTabSkeleton";
import LogosTabSkeleton from "./LogosTabSkeleton";
import ComponentsTabSkeleton from "./ComponentsTabSkeleton";

import { SettingsTab } from "../../../../typings";
import Header from "../../../builder/layout/Header";

const SettingsFormSkeleton = () => {
  const { activeTab } = useParams();

  const isActiveTab = (tab: SettingsTab) => {
    return activeTab === tab;
  };

  return (
    <Box m={30} w="auto">
      <Header />
      {isActiveTab("colors") && <ColorsTabSkeleton />}
      {isActiveTab("typography") && <TypographyTabSkeleton />}
      {isActiveTab("logos") && <LogosTabSkeleton />}
      {isActiveTab("components") && <ComponentsTabSkeleton />}
    </Box>
  );
};

export default SettingsFormSkeleton;
